import { ErrorMessage, Field, Form } from "formik";
import { Btn, H6 } from "../../../../AbstractElements";
import { AgreeCondition, ChooseFiles, City, Description, FirstName, LooksGood, MarkFirstNamePlaceholder, Passwordvalidation, PayMethodTitle, SelectThemeTitle, State, SubmitButton, TextAreaPlaceHolder, Zip } from "../../../../Constant";
import { Col, FormFeedback, FormGroup, Label, Row } from "reactstrap";
import { VALIDATION_FORM_STATE, VALIDATION_RADIO, VALIDATION_THEME_STATE } from "../../../../Data/FormControl/FormValidation";
import { FormValidationsProp } from "../../../../Type/FormValidation";

export const FormValidations = ({errors,submitErrors,setSubmitError}: FormValidationsProp) => {
  return (
    <Form className="g-3 custom-input">
      <Row>
      <Col sm="12">
        <Label check>{FirstName}</Label>
        <Field name="firstname" type="text" className={`form-control ${submitErrors && `${errors.firstname ? "is-invalid" : "is-valid"}`}`} placeholder={MarkFirstNamePlaceholder} />
        <ErrorMessage name="firstname" component="span" className="invalid-feedback" />
        <FormFeedback valid>{LooksGood}</FormFeedback>
      </Col>
      <Col sm="12">
        <Label check>{Passwordvalidation}</Label>
        <Field name="password" type="text" className={`form-control ${submitErrors && `${errors.password ? "is-invalid" : "is-valid"}`}`} />
        <ErrorMessage name="password" component="span" className="invalid-feedback" />
      </Col>
      <Col sm="12">
        <Label check>{State}</Label>
        <Field name="state" as="select" className={`form-control ${submitErrors && `${errors.state ? "is-invalid" : "is-valid"}`}`}>
          {VALIDATION_FORM_STATE.map((item, index) => (<option value={item} key={index}>{item}</option>))}
        </Field>
        <ErrorMessage name="state" component="span" className="invalid-feedback" />
        <FormFeedback valid>{LooksGood}</FormFeedback>
      </Col>
      <Col md="6">
        <Label check>{City}</Label>
        <Field name="city" type="text" className={`form-control ${submitErrors && `${errors.city ? "is-invalid" : "is-valid"}`}`} />
        <ErrorMessage name="city" component="span" className="invalid-feedback"></ErrorMessage>
        <FormFeedback valid>{LooksGood}</FormFeedback>
      </Col>
      <Col md="6">
        <Label check>{Zip}</Label>
        <Field name="zip" type="text" className={`form-control ${submitErrors && `${errors.zip ? "is-invalid" : "is-valid"}`}`} />
        <ErrorMessage name="zip" component="span" className="invalid-feedback"></ErrorMessage>
        <FormFeedback valid>{LooksGood}</FormFeedback>
      </Col>
      <Col sm="12">
        <div className="card-wrapper border rounded-3 checkbox-checked">
          <H6 className="sub-title">{PayMethodTitle}</H6>
          <div className="radio-form">
            {VALIDATION_RADIO.map(({ id, text }, index) => (
              <FormGroup check key={index}>
                <Field className="form-check-input" id={`validationFormCheck${id}`} type="radio" name="payment" value={text} />
                <Label htmlFor={`validationFormCheck${id}`} className={`${submitErrors && ` ${errors.payment ? "text-danger" : "text-success"}`}`} check>{text}</Label>
              </FormGroup>
            ))}
          </div>
        </div>
      </Col>
      <Col sm="12">
        <Field as="select" name="theme" className={`form-select ${submitErrors && `${errors.theme ? "is-invalid" : "is-valid"}`}`}>
          <option defaultValue="">{SelectThemeTitle}</option>
          {VALIDATION_THEME_STATE.map((item, index) => (<option value={item} key={index}>{item}</option>))}
        </Field>
        <ErrorMessage name="theme" component="span" className="invalid-feedback" />
      </Col>
      <div className="col-12">
        <Label check>{ChooseFiles}</Label>
        <Field name="file" className={`form-control ${submitErrors && `${errors.file ? "is-invalid" : "is-valid"}`}`} type="file" />
        <ErrorMessage name="file" component="span" className="invalid-feedback"></ErrorMessage>
      </div>
      <Col sm="12">
        <Label check>{Description}</Label>
        <Field as="textarea" name="description" className={`form-control ${submitErrors && `${errors.description ? "is-invalid" : "is-valid"}`}`} placeholder={TextAreaPlaceHolder}></Field>
        <ErrorMessage name="description" className="invalid-feedback" component="span" />
      </Col>
      <Col sm="12">
        <FormGroup check>
          <Field name="terms" className="form-check-input" id="invalidCheck" type="checkbox" value="Agree to terms and conditions" />
          <Label className={`${submitErrors && ` ${errors.terms ? "text-danger" : "text-success"}`}`} htmlFor="invalidCheck" check>{AgreeCondition}</Label>
        </FormGroup>
      </Col>
      <Col sm="12">
        <Btn color="primary" type="submit" onClick={() => setSubmitError(true)}>{SubmitButton}</Btn>
      </Col>
      </Row>
    </Form>
  );
};
